<template>
  <router-view/>
</template>
<script setup >
import { onMounted } from 'vue'
import {getCityDataApi} from "@/service";
import {useStore} from "vuex";
const store=useStore()
if(localStorage.getItem('cityData')){
  store.commit('setCllist',JSON.parse((localStorage.cityData)))
}
getCityDataApi({
  level:1
}).then(res=>{
  console.log('看看国家',res)
  if(res.data.code==1){
    localStorage.setItem('cityData',JSON.stringify(res.data.data))
    store.commit('setCllist',res.data.data)
  }
})
</script>
<style lang="less">
body{
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  margin: 0 ;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  overflow-y: scroll;
  background: linear-gradient(rgba(22, 119, 255, 0.12), #f5f7fa);
  &::-webkit-scrollbar{
    width: 0;
  }
}
.cell{
  font-size: 12px;
}
</style>
